/** public 기준 QR 이미지 경로 (파일은 public/images에 배치) */
export const KAKAO_QR_IMAGE_SRC = "/images/1776472054927.jpg";

/** 클립보드에 복사할 카카오톡 검색용 ID */
export const KAKAO_TALK_ID_COPY = "dkexpress";

/** 화면에 표시할 ID 텍스트 */
export const KAKAO_TALK_ID_LABEL = "dkexpress";
